// components/ProtectedRoute.js
import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { AuthContext } from "../context/AuthContext";

const ProtectedRoute = ({ children, requiredRole = null }) => {
  const { token, role, loading } = useContext(AuthContext);
  const { i18n } = useTranslation();
  const currentLang = i18n.language || "en";

  if (loading) return <div>Loading...</div>;

  if (!token) {
    return <Navigate to={`/${currentLang}/sign-in`} replace />;
  }

  if (requiredRole === "admin" && role?.name !== "admin") {
    return <Navigate to={`/${currentLang}/account`} replace />;
  }

  return children;
};

export default ProtectedRoute;
